const RescheduleConfirmation = () => {
  return (
    <p>
      <center>Reunión reagendada con éxito!</center>
      </p>
  );
};

export default RescheduleConfirmation;
